import { render } from "./SectionStepThree.vue?vue&type=template&id=64884ab6"
import script from "./SectionStepThree.vue?vue&type=script&lang=js"
export * from "./SectionStepThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__